import axios from "axios";
import { toast } from "react-toastify";
import {
  getLocalJWT,
  getSessionAbortSignal,
  logout,
} from "../components/functions/utilities";
import { history } from "../Router/History";

// Guards against multiple simultaneous 401 responses all calling logout()
// + history.replace("/login") at once, which causes the login-page flicker.
let isLoggingOut = false;

let API = axios.create({
  baseURL: `${import.meta.env.VITE_JIGSAW_DEV_REST_LOCATION}`,
  responseType: "json",
  headers: {
    "ngrok-skip-browser-warning": "69420",
  },
});

API.interceptors.request.use((req) => {
  let token = getLocalJWT();
  if (token) req.headers.Authorization = "Bearer " + token;
  if (!req.signal) req.signal = getSessionAbortSignal();
  return req;
});

API.interceptors.response.use(
  (res) => {
    return res;
  },
  (error) => {
    // Ignore errors from aborted requests (e.g. sessionAbortController.abort()
    // during logout) — they have no response and shouldn't trigger auth logic.
    if (error.code === "ERR_NETWORK" || error.name === "AbortError" || !error.response) {
      return Promise.reject(error);
    }
    if (error.response?.status === 403) {
      toast.error("You do not have access to the workspace");
      history.push("/Reports");
    }
    if (error.response?.status === 401) {
      // Guard against multiple simultaneous 401s: only logout + redirect once.
      if (!isLoggingOut) {
        isLoggingOut = true;
        logout();
        history.replace("/login");
        // Reset the flag after the redirect completes so a future session
        // can handle 401s normally.
        setTimeout(() => { isLoggingOut = false; }, 1000);
      }
    }
    //
    return Promise.reject(error);
  }
);

export default API;
